import { UserProcess, UserProcessStatus } from './user-process';
import { Pagination } from './http';

export interface Task extends UserProcess {}

export interface SearchTasksPayload extends Pagination {
  status?: UserProcessStatus;
  creatorId?: string;
}
